import { render, staticRenderFns } from "./u-card-outlined-tile.vue?vue&type=template&id=228d7672&scoped=true&"
import script from "./u-card-outlined-tile.vue?vue&type=script&lang=js&"
export * from "./u-card-outlined-tile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228d7672",
  null
  
)

export default component.exports